import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role !== "admin") {
        logout();
        toast.error("Bu giriş yalnızca stüdyo yöneticileri içindir.");
        return;
      }
      toast.success("Stüdyo paneline hoş geldiniz");
      navigate("/admin");
    } catch (err) {
      if (err.response?.status === 403) {
        toast.error("E-posta adresiniz doğrulanmamış.");
        return;
      }
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-gold/5 blur-3xl rounded-full pointer-events-none" />
      <form onSubmit={submit} className="w-full max-w-md relative" data-testid="admin-login-form">
        <div className="bg-[#0A0A0A] border border-gold/25 rounded-2xl p-10 shadow-[0_0_60px_rgba(212,175,55,0.08)]">
          <div className="w-14 h-14 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center mb-6">
            <ShieldCheck className="w-7 h-7 text-gold" />
          </div>
          <p className="text-sm uppercase tracking-[0.3em] text-gold mb-2">Stüdyo Yönetimi</p>
          <h1 className="font-serif text-4xl mb-2">Yönetici Girişi</h1>
          <p className="text-white/50 text-sm mb-8">Bu alan yalnızca İnce Fikirler stüdyo ekibi içindir.</p>
          <div className="space-y-5">
            <div>
              <Label className="text-white/70">Yönetici E-posta</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="admin-login-email-input"
                className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold h-11"
                placeholder="stüdyo@incefikirler.tv" />
            </div>
            <div>
              <Label className="text-white/70">Şifre</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                data-testid="admin-login-password-input"
                className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold h-11"
                placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading} data-testid="admin-login-submit-button"
              className="w-full bg-gold text-black hover:bg-gold-light h-11 rounded-md">
              {loading ? "Giriş yapılıyor…" : "Yönetici Olarak Giriş Yap"}
            </Button>
          </div>
          <p className="text-sm text-white/40 mt-6 text-center">
            Müşteri misiniz?{" "}
            <Link to="/login" className="text-gold hover:underline" data-testid="go-customer-login-link">Müşteri girişi</Link>
          </p>
        </div>
      </form>
    </div>
  );
}
